/**
 * Validates a value to check for leading whitespace or whitespace-only strings.
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name min
 * @memberof combinators
 */
async function validate(value, context) {
  // always pass on a null input
  if (value === undefined || value === null || value === '') {
    return Promise.resolve(null);
  }

  // Check for leading whitespace
  const isFirstCharacterWhiteSpace = /^\s/.test(value);

  // Check for whitespace only
  const isWhitespace = /^\s*$/.test(value);

  return Promise.resolve((isFirstCharacterWhiteSpace || isWhitespace) ? 'whitespace' : null);
}

module.exports = validate;
